// Formatierungshelfer für NEKO-Tools

export function formatEuro(betrag: number): string {
  return betrag.toLocaleString("de-DE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });
}

export function formatProzent(satz: number, nachkommastellen = 0): string {
  return `${(satz * 100).toFixed(nachkommastellen)} %`;
}

export function formatKWh(kwh: number): string {
  if (kwh >= 1000) {
    return `${(kwh / 1000).toLocaleString("de-DE", { maximumFractionDigits: 1 })} MWh`;
  }
  return `${kwh.toLocaleString("de-DE")} kWh`;
}

export function formatKWp(kwp: number): string {
  return `${kwp.toLocaleString("de-DE", { maximumFractionDigits: 1 })} kWp`;
}
